import { FC, useEffect, useState } from 'react';
import { CartProvider } from '../../../lib/context/cart/CartContext';
import { ChatProvider } from '../../../lib/context/chat/ChatContext';
import { ToastProvider } from '../../../lib/context/toast/ToastContext';
import { useOutsideClick } from '../../../lib/hooks/useOutsideClick';
import { TrackingProvider } from '../../../lib/tracking/TrackingContext';
import { getQueryParam } from '../../../lib/utils/queryParams';
import { WelcomeBanner } from '../../atoms/WelcomeBanner';
import { CartProgress } from '../../molecules/CartProgress';
import { Header } from '../../molecules/Header';
import { MessageList } from '../../molecules/MessageList/MessageList';
import { PlanComponent } from '../../molecules/PlanComponent/PlanComponent';
import { UserInput } from '../../molecules/UserInput/UserInput';
import { CartComponent } from '../../molecules/CartComponent/CartComponent';

import type { ChatbotProps } from './Chatbot.types';


import styles from './Chatbot.module.css';
export const Chatbot: FC<ChatbotProps> = ({ user, deliveryDate, isApp, cartUpdated }) => {
    const [showCart, setShowCart] = useState(false);
    const [showChat, setShowChat] = useState(isApp || false);
    const [deliveryDateState, setDeliveryDateState] = useState<string | null>(deliveryDate ?? null);

    useEffect(() => {
        const date = getQueryParam('date');
        const currentDate = (date ?? deliveryDate) as string;
        setDeliveryDateState(currentDate);
    }, [deliveryDate]);

    const ref = useOutsideClick<HTMLDivElement>(() => {
        handleOnClose();
    });

    const handleCartUpdated = () => {
        if (typeof cartUpdated === 'function') {
            cartUpdated();
        }
    }

    const handleOnClose = () => {
        setShowChat(false)
    }

    const handleToggleCart = () => {
        setShowCart(!showCart);
    }

    return (
        <TrackingProvider>
            <CartProvider deliveryDate={deliveryDateState} cartUpdated={handleCartUpdated}>
                <ChatProvider initialUser={user} deliveryDate={deliveryDateState}>
                    {
                        !isApp && (
                            <WelcomeBanner onClick={() => setShowChat(true)} />
                        )
                    }

                    {showChat && (
                        <div className={styles.aiWaiter} ref={ref}>
                            <ToastProvider>
                                {showCart && (
                                    <CartComponent deliveryDate={deliveryDateState} onCloseCart={handleToggleCart} />
                                )}
                                <Header onCloseClick={handleOnClose} onShowCart={handleToggleCart} />
                                <PlanComponent />
                                <CartProgress />
                                <MessageList />
                                <UserInput />
                            </ToastProvider>
                        </div>
                    )}
                </ChatProvider>
            </CartProvider>
        </TrackingProvider>
    );
};